import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy, inject } from '@angular/core';
import { TranslateService } from './translate.service';
import { Subscription } from 'rxjs';
import { merge } from 'rxjs';

/**
 * TranslatePipe - Template'lerde çeviri yapmak için kullanılan pipe
 * 
 * Kullanım örnekleri:
 * - {{ 'TXT00001' | translate }}
 * - {{ 'TXT00028' | translate: '5' }}
 * - {{ 'TXT00132' | translate: errorMessage }}
 */
@Pipe({
  name: 'translate',
  pure: false, // Dil değişikliklerini algılamak için pure: false
  standalone: true,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private translateService = inject(TranslateService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private lastKey?: string;
  private lastParams?: (string | number | Record<string, unknown>)[];
  private lastValue?: string;
  private subscription?: Subscription;

  constructor() {
    // Dil değişikliklerini ve çeviri yüklemelerini dinle
    this.subscription = merge(
      this.translateService.languageChange,
      this.translateService.translationsLoaded
    ).subscribe(() => {
      this.lastKey = undefined; // Cache'i temizle
      this.changeDetectorRef.markForCheck();
    });
  }

  transform(key: string, ...params: (string | number | Record<string, unknown>)[]): string {
    // Cache kontrolü
    if (
      this.lastKey === key &&
      JSON.stringify(this.lastParams) === JSON.stringify(params)
    ) {
      return this.lastValue || key;
    }

    // Yeni çeviri yap
    this.lastKey = key;
    this.lastParams = params;
    this.lastValue = this.translateService.getText(key, ...params);

    return this.lastValue;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

